"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const crypto_1 = require("./crypto");
const enc_utils_1 = require("enc-utils");
const bn_js_1 = __importDefault(require("bn.js"));
exports.TWO_POW_64_BN = crypto_1.hexToBN('10000000000000000');
exports.TWO_POW_32_BN = crypto_1.hexToBN('100000000');
exports.TWO_POW_128_BN = crypto_1.hexToBN('100000000000000000000000000000000');
exports.TWO_POW_250_BN = crypto_1.hexToBN('400000000000000000000000000000000000000000000000000000000000000');
exports.TWO_POW_251_BN = crypto_1.hexToBN('800000000000000000000000000000000000000000000000000000000000000');
const LIMIT_ORDER_WITH_FEES = 3;
const TRANSFER = 4;
const CONDITIONAL_TRANSFER = 5;
const WITHDRAWAL = 6;
function getPerpetualLimitOrderMsgHash(assetIdSynthetic, assetIdCollateral, isBuyingSynthetic, assetIdFee, amountSynthetic, amountCollateral, amountFee, nonce, positionId, expirationTimestamp, hash = crypto_1.pedersen) {
    const assetIdSyntheticBn = crypto_1.hexToBN(assetIdSynthetic);
    const assetIdCollateralBn = crypto_1.hexToBN(assetIdCollateral);
    const assetIdFeeBn = crypto_1.hexToBN(assetIdFee);
    const amountFeeBn = crypto_1.hexToBN(amountFee);
    const nonceBn = crypto_1.hexToBN(nonce);
    const positionIdBn = crypto_1.hexToBN(positionId);
    const expirationTimestampBn = crypto_1.hexToBN(expirationTimestamp);
    let assetIdSell;
    let assetIdBuy;
    let amountSell;
    let amountBuy;
    if (isBuyingSynthetic) {
        assetIdSell = crypto_1.hexToBN(assetIdCollateral);
        assetIdBuy = crypto_1.hexToBN(assetIdSynthetic);
        amountSell = crypto_1.hexToBN(amountCollateral);
        amountBuy = crypto_1.hexToBN(amountSynthetic);
    }
    else {
        assetIdSell = crypto_1.hexToBN(assetIdSynthetic);
        assetIdBuy = crypto_1.hexToBN(assetIdCollateral);
        amountSell = crypto_1.hexToBN(amountSynthetic);
        amountBuy = crypto_1.hexToBN(amountCollateral);
    }
    crypto_1.assertInRange(assetIdSyntheticBn, crypto_1.ZERO_BN, exports.TWO_POW_250_BN, 'assetIdSynthetic');
    crypto_1.assertInRange(assetIdCollateralBn, crypto_1.ZERO_BN, exports.TWO_POW_250_BN, 'assetIdCollateral');
    crypto_1.assertInRange(assetIdFeeBn, crypto_1.ZERO_BN, exports.TWO_POW_250_BN, 'assetIdFee');
    crypto_1.assertInRange(amountSell, crypto_1.ZERO_BN, exports.TWO_POW_64_BN, 'amountSell');
    crypto_1.assertInRange(amountBuy, crypto_1.ZERO_BN, exports.TWO_POW_64_BN, 'amountBuy');
    crypto_1.assertInRange(amountFeeBn, crypto_1.ZERO_BN, exports.TWO_POW_64_BN, 'amountFee');
    crypto_1.assertInRange(nonceBn, crypto_1.ZERO_BN, exports.TWO_POW_32_BN, 'nonce');
    crypto_1.assertInRange(positionIdBn, crypto_1.ZERO_BN, exports.TWO_POW_64_BN, 'positionId');
    crypto_1.assertInRange(expirationTimestampBn, crypto_1.ZERO_BN, exports.TWO_POW_32_BN, 'expirationTimestamp');
    let msg = hash([assetIdSell, assetIdBuy]);
    msg = hash([msg, assetIdFeeBn]);
    let packedMsg0 = crypto_1.hexToBN(amountSell);
    packedMsg0 = packedMsg0.ushln(64).add(amountBuy);
    packedMsg0 = packedMsg0.ushln(64).add(amountFeeBn);
    packedMsg0 = packedMsg0.ushln(32).add(nonceBn);
    msg = hash([msg, packedMsg0]);
    let packedMsg1 = new bn_js_1.default(LIMIT_ORDER_WITH_FEES, 10);
    packedMsg1 = packedMsg1.ushln(64).add(positionIdBn);
    packedMsg1 = packedMsg1.ushln(64).add(positionIdBn);
    packedMsg1 = packedMsg1.ushln(64).add(positionIdBn);
    packedMsg1 = packedMsg1.ushln(32).add(expirationTimestampBn);
    packedMsg1 = packedMsg1.ushln(17);
    return enc_utils_1.sanitizeHex(hash([msg, packedMsg1]));
}
exports.getPerpetualLimitOrderMsgHash = getPerpetualLimitOrderMsgHash;
function getPerpetualWithdrawalMsgHash(assetIdCollateral, positionId, nonce, expirationTimestamp, amount, hash = crypto_1.pedersen) {
    const assetIdCollateralBn = crypto_1.hexToBN(assetIdCollateral);
    const positionIdBn = crypto_1.hexToBN(positionId);
    const nonceBn = crypto_1.hexToBN(nonce);
    const amountBn = crypto_1.hexToBN(amount);
    const expirationTimestampBn = crypto_1.hexToBN(expirationTimestamp);
    crypto_1.assertInRange(assetIdCollateralBn, crypto_1.ZERO_BN, exports.TWO_POW_250_BN, 'assetIdCollateral');
    crypto_1.assertInRange(nonceBn, crypto_1.ZERO_BN, exports.TWO_POW_32_BN, 'nonce');
    crypto_1.assertInRange(positionIdBn, crypto_1.ZERO_BN, exports.TWO_POW_64_BN, 'positionId');
    crypto_1.assertInRange(expirationTimestampBn, crypto_1.ZERO_BN, exports.TWO_POW_32_BN, 'expirationTimestamp');
    crypto_1.assertInRange(amountBn, crypto_1.ZERO_BN, exports.TWO_POW_64_BN, 'amount');
    let packedMsg = new bn_js_1.default(WITHDRAWAL, 10);
    packedMsg = packedMsg.ushln(64).add(positionIdBn);
    packedMsg = packedMsg.ushln(32).add(nonceBn);
    packedMsg = packedMsg.ushln(64).add(amountBn);
    packedMsg = packedMsg.ushln(32).add(expirationTimestampBn);
    packedMsg = packedMsg.ushln(49);
    return enc_utils_1.sanitizeHex(hash([assetIdCollateral, packedMsg]));
}
exports.getPerpetualWithdrawalMsgHash = getPerpetualWithdrawalMsgHash;
function getPerpetualTransferMsgHash(assetId, assetIdFee, receiverPublicKey, senderPositionId, receiverPositionId, srcFeePositionId, nonce, amount, maxAmountFee, expirationTimestamp, hash = crypto_1.pedersen) {
    const assetIdBn = crypto_1.hexToBN(assetId);
    const assetIdFeeBn = crypto_1.hexToBN(assetIdFee);
    const receiverPublicKeyBn = crypto_1.hexToBN(receiverPublicKey);
    const senderPositionIdBn = crypto_1.hexToBN(senderPositionId);
    const receiverPositionIdBn = crypto_1.hexToBN(receiverPositionId);
    const srcFeePositionIdBn = crypto_1.hexToBN(srcFeePositionId);
    const nonceBn = crypto_1.hexToBN(nonce);
    const amountBn = crypto_1.hexToBN(amount);
    const maxAmountFeeBn = crypto_1.hexToBN(maxAmountFee);
    const expirationTimestampBn = crypto_1.hexToBN(expirationTimestamp);
    crypto_1.assertInRange(amountBn, crypto_1.ZERO_BN, exports.TWO_POW_64_BN, 'amount');
    crypto_1.assertInRange(assetIdBn, crypto_1.ZERO_BN, exports.TWO_POW_250_BN, 'assetId');
    crypto_1.assertInRange(assetIdFeeBn, crypto_1.ZERO_BN, exports.TWO_POW_250_BN, 'assetIdFee');
    crypto_1.assertInRange(expirationTimestampBn, crypto_1.ZERO_BN, exports.TWO_POW_32_BN, 'expirationTimestamp');
    crypto_1.assertInRange(maxAmountFeeBn, crypto_1.ZERO_BN, exports.TWO_POW_64_BN, 'maxAmountFee');
    crypto_1.assertInRange(nonceBn, crypto_1.ZERO_BN, exports.TWO_POW_32_BN, 'nonce');
    crypto_1.assertInRange(receiverPositionIdBn, crypto_1.ZERO_BN, exports.TWO_POW_64_BN, 'receiverPositionId');
    crypto_1.assertInRange(receiverPublicKeyBn, crypto_1.ZERO_BN, exports.TWO_POW_251_BN, 'receiverPublicKey');
    crypto_1.assertInRange(senderPositionIdBn, crypto_1.ZERO_BN, exports.TWO_POW_64_BN, 'senderPositionIdBn');
    let msg = hash([assetIdBn, assetIdFeeBn]);
    msg = hash([msg, receiverPublicKeyBn]);
    let packedMsg0 = senderPositionIdBn;
    packedMsg0 = packedMsg0.ushln(64).add(receiverPositionIdBn);
    packedMsg0 = packedMsg0.ushln(64).add(srcFeePositionIdBn);
    packedMsg0 = packedMsg0.ushln(32).add(nonceBn);
    msg = hash([msg, packedMsg0]);
    let packedMsg1 = new bn_js_1.default(TRANSFER, 10);
    packedMsg1 = packedMsg1.ushln(64).add(amountBn);
    packedMsg1 = packedMsg1.ushln(64).add(maxAmountFeeBn);
    packedMsg1 = packedMsg1.ushln(32).add(expirationTimestampBn);
    packedMsg1 = packedMsg1.ushln(81);
    return enc_utils_1.sanitizeHex(hash([msg, packedMsg1]));
}
exports.getPerpetualTransferMsgHash = getPerpetualTransferMsgHash;
function getPerpetualConditionalTransferMsgHash(assetId, assetIdFee, receiverPublicKey, condition, senderPositionId, receiverPositionId, srcFeePositionId, nonce, amount, maxAmountFee, expirationTimestamp, hash = crypto_1.pedersen) {
    const assetIdBn = crypto_1.hexToBN(assetId);
    const assetIdFeeBn = crypto_1.hexToBN(assetIdFee);
    const receiverPublicKeyBn = crypto_1.hexToBN(receiverPublicKey);
    const conditionBn = crypto_1.hexToBN(condition);
    const senderPositionIdBn = crypto_1.hexToBN(senderPositionId);
    const receiverPositionIdBn = crypto_1.hexToBN(receiverPositionId);
    const srcFeePositionIdBn = crypto_1.hexToBN(srcFeePositionId);
    const nonceBn = crypto_1.hexToBN(nonce);
    const amountBn = crypto_1.hexToBN(amount);
    const maxAmountFeeBn = crypto_1.hexToBN(maxAmountFee);
    const expirationTimestampBn = crypto_1.hexToBN(expirationTimestamp);
    crypto_1.assertInRange(amountBn, crypto_1.ZERO_BN, exports.TWO_POW_64_BN, 'amount');
    crypto_1.assertInRange(assetIdBn, crypto_1.ZERO_BN, exports.TWO_POW_250_BN, 'assetId');
    crypto_1.assertInRange(assetIdFeeBn, crypto_1.ZERO_BN, exports.TWO_POW_250_BN, 'assetIdFee');
    crypto_1.assertInRange(conditionBn, crypto_1.ZERO_BN, exports.TWO_POW_251_BN, 'condition');
    crypto_1.assertInRange(expirationTimestampBn, crypto_1.ZERO_BN, exports.TWO_POW_32_BN, 'expirationTimestamp');
    crypto_1.assertInRange(srcFeePositionIdBn, crypto_1.ZERO_BN, exports.TWO_POW_64_BN, 'srcFeePositionId');
    crypto_1.assertInRange(maxAmountFeeBn, crypto_1.ZERO_BN, exports.TWO_POW_64_BN, 'maxAmountFee');
    crypto_1.assertInRange(nonceBn, crypto_1.ZERO_BN, exports.TWO_POW_32_BN, 'nonce');
    crypto_1.assertInRange(receiverPositionIdBn, crypto_1.ZERO_BN, exports.TWO_POW_64_BN, 'receiverPositionId');
    crypto_1.assertInRange(receiverPublicKeyBn, crypto_1.ZERO_BN, exports.TWO_POW_251_BN, 'receiverPublicKeyBn');
    crypto_1.assertInRange(senderPositionIdBn, crypto_1.ZERO_BN, exports.TWO_POW_64_BN, 'senderPositionId');
    let msg = hash([assetIdBn, assetIdFeeBn]);
    msg = hash([msg, receiverPublicKeyBn]);
    msg = hash([msg, conditionBn]);
    let packedMsg0 = senderPositionIdBn;
    packedMsg0 = packedMsg0.ushln(64).add(receiverPositionIdBn);
    packedMsg0 = packedMsg0.ushln(64).add(srcFeePositionIdBn);
    packedMsg0 = packedMsg0.ushln(32).add(nonceBn);
    msg = hash([msg, packedMsg0]);
    let packedMsg1 = new bn_js_1.default(CONDITIONAL_TRANSFER, 10);
    packedMsg1 = packedMsg1.ushln(64).add(amountBn);
    packedMsg1 = packedMsg1.ushln(64).add(maxAmountFeeBn);
    packedMsg1 = packedMsg1.ushln(32).add(expirationTimestampBn);
    packedMsg1 = packedMsg1.ushln(81);
    return enc_utils_1.sanitizeHex(hash([msg, packedMsg1]));
}
exports.getPerpetualConditionalTransferMsgHash = getPerpetualConditionalTransferMsgHash;
function buildCondition(factRegistryAddress, fact) {
    const conditionHash = crypto_1.solidityKeccak(['address', 'bytes32'], [factRegistryAddress, fact]);
    const hash = new bn_js_1.default(conditionHash.toString('hex'), 16).and(exports.TWO_POW_250_BN.sub(crypto_1.ONE_BN));
    return enc_utils_1.sanitizeHex(hash.toString('hex'));
}
exports.buildCondition = buildCondition;
//# sourceMappingURL=perpetualMessages.js.map